import React from 'react'

type Props = {
  className?: string
  // Stroke color; defaults to currentColor so the glyph inherits the parent's
  // `color` (e.g. the platform toggle's active/inactive treatment).
  color?: string
  size?: number
}

// Outline (hollow) Apple logo for the Live Updates platform toggle (Figma
// 368:6871). Font Awesome only ships a SOLID `fa-apple`, so this stroke glyph
// is a dedicated icon rather than a font variant. Decorative — the toggle
// button carries the accessible label — so it is aria-hidden.
const BrandApple = ({
  className,
  color = 'currentColor',
  size = 16,
}: Props) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66699 8.61869C2.66699 6.82535 3.38033 4.67202 5.52433 4.67202C6.30966 4.67202 7.18099 5.39002 7.66699 5.39002C8.14566 5.39002 9.14366 4.59202 10.167 4.67202C10.559 4.69869 11.9363 5.03669 12.667 6.10735C12.607 6.14002 10.8677 6.70269 10.881 8.25935C10.901 10.1234 12.647 10.4054 12.667 10.4127C12.667 11.8474 10.881 14 9.80966 14C8.73833 14 8.60433 13.6414 7.66699 13.6414C6.72366 13.6414 6.30099 13.9667 5.52433 14C4.09566 14 2.66699 10.7714 2.66699 8.61869Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.94281 2.27618C8.69276 2.52623 8.35362 2.66671 8 2.66671C8 2.31309 8.14048 1.97395 8.39052 1.7239C8.64057 1.47385 8.97971 1.33337 9.33333 1.33337C9.33333 1.687 9.19286 2.02613 8.94281 2.27618Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default BrandApple
